<span *ngIf="!multiple">
  <ng-select [items]="users"
             [(ngModel)]="user" [ngModelOptions]="{standalone: true}"
             [multiple]="multiple"
             [disabled]="disabled" [loading]="loading"
             [placeholder]="placeholder"
             (focus)="loadListUsers(roles)"
             (change)="onChange($event)" [searchFn]="customSearchFn">
  <ng-template ng-label-tmp let-item="item">
    <div style="margin: 3px;">
      <div class="media mt-1">
        <div class="mr-1 img-profil__photo28" *ngIf="!item?.image" [innerHTML]="item?.firstName|user2Lettre:item?.lastName"></div>
        <img style="width: 30px;" class="mr-1 img-thumbnail rounded-circle thumb28" *ngIf="item?.image" src="{{item?.image}}"
             alt="Image" appImgFallback="assets/img/default-image.png"/>
        <div class="media-body">
          <h5 class="mt-1 text-bold mr-1">
            <span [innerHTML]="item?.firstName"></span> &nbsp;<span [innerHTML]="item?.lastName"></span>
          </h5>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    <div class="media">

      <div class="mr-2 img-profil__photo28" *ngIf="!item?.image" [innerHTML]="item?.firstName|user2Lettre:item?.lastName"></div>
      <img class="mr-1 img-thumbnail rounded-circle thumb28" *ngIf="item?.image" src="{{item?.image}}"
           tooltipHtml="{{item?.firstName}} {{item?.lastName}}" alt="Image" appImgFallback="assets/img/default-image.png"/>

      <div class="media-body">
        <h5 class="m-0 text-bold mr-1">
          <span [innerHTML]="item?.firstName"></span> &nbsp;<span [innerHTML]="item?.lastName"></span>
        </h5>
        <div class="text-sm text-muted" [ngStyle]="{color:  '#FFFFFF' }" [innerHTML]="item?.email" style="display: inline-block;font-size: 11px"></div> |
        <div class="text-sm text-muted" [ngStyle]="{color:  '#FFFFFF' }" [innerHTML]="item?.role" style="display: inline-block;font-size: 11px"></div>
      </div>

    </div>
  </ng-template>
</ng-select>
</span>


<span *ngIf="multiple">
  <ng-select [items]="users"
             [(ngModel)]="selectedIds" [ngModelOptions]="{standalone: true}"
             [multiple]="multiple"
             [disabled]="disabled"
             [placeholder]="placeholder"
             bindValue="id"
             (focus)="loadListUsers(roles)"
             (change)="onChange($event)" [searchFn]="customSearchFn">
  <ng-template ng-label-tmp let-item="item">
    <div style="margin: 3px;">
      <div class="media mt-1">
        <div class="mr-1 img-profil__photo28" *ngIf="!item?.image" [innerHTML]="item?.firstName|user2Lettre:item?.lastName"></div>
        <img style="width: 30px;" class="mr-1 img-thumbnail rounded-circle thumb28" *ngIf="item?.image" src="{{item?.image}}"
             alt="Image" appImgFallback="assets/img/default-image.png"/>
        <div class="media-body">
          <h5 class="mt-1 text-bold mr-1">
            <span [innerHTML]="item?.firstName"></span> &nbsp;<span [innerHTML]="item?.lastName"></span>
          </h5>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    <div class="media">

      <div class="mr-2 img-profil__photo28" *ngIf="!item?.image" [innerHTML]="item?.firstName|user2Lettre:item?.lastName"></div>
      <img style="width: 30px;" class="mr-1 img-thumbnail rounded-circle thumb28" *ngIf="item?.image" src="{{item?.image}}"
           tooltipHtml="{{item?.firstName}} {{item?.lastName}}" alt="Image" appImgFallback="assets/img/default-image.png"/>

      <div class="media-body">
        <h5 class="m-0 text-bold mr-1">
          <span [innerHTML]="item?.firstName"></span> &nbsp;<span [innerHTML]="item?.lastName"></span>
        </h5>
        <div class="text-sm text-muted" [ngStyle]="{color:  '#FFFFFF' }" [innerHTML]="item?.email" style="display: inline-block;font-size: 11px"></div>
      </div>

    </div>
  </ng-template>
</ng-select>
</span>
